
// For Custom Confirm Dialog Preset
function leaveEdit(_) {
  let ctx = window.vue
  return {
    title: ctx.$i18n.t('common.confirm'),
    text: ctx.$i18n.t('app.tmp_or5SeAmlXJUO4bhIHaWV0'),
    persistent: true,
    actions: [
      { key: true, text: ctx.$i18n.t('common.yes'), color: 'primary' },
      {
        key: false,
        text: ctx.$i18n.t('common.no'),
        color: '#AEAEAE',
        props: {
          style: { color: '#FFFFFF' }
        }
      },
    ]
  }
}

function deleteConfirm(_) {
  let ctx = window.vue
  return {
    title: ctx.$i18n.t('common.confirm'),
    text: ctx.$i18n.t('app.tmp_GvK2MEdSufCNcxbKF4Tvl'),
    persistent: true,
    actions: [
      { key: true, text: ctx.$i18n.t('common.yes'), color: 'error' },
      {
        key: false,
        text: ctx.$i18n.t('common.no'),
        color: '#AEAEAE',
        props: {
          style: { color: '#FFFFFF' }
        }
      },
    ]
  }
}

function baseConfirm(_) {
  let ctx = window.vue
  return {
    title: ctx.$i18n.t('common.confirm'),
    text: '{customMessage}',
    persistent: true,
    actions: [
      { key: true, text: 'OK', color: 'primary' },
      {
        key: false,
        text: ctx.$i18n.t('C30201.PgC30201.VFid2EvV9tJdHBFc9rriP'),
        color: '#AEAEAE',
        props: {
          style: { color: '#FFFFFF' }
        }
      }
    ]
  }
}

export default {
  leaveEdit,
  deleteConfirm,
  baseConfirm
}
